var utils = (function() {
    return {
        request: {
            post: function (url, postData) {

                var _postData = undefined;

                if (postData) {
                    _postData = JSON.stringify(postData);
                }

                return $.ajax(url,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        data: _postData
                    });
            }
        },
        script: {
            load: (function (w, d, s) {
                return function (source) {
                    var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s); j.async = true; j.src = source; f.parentNode.insertBefore(j, f);
                }
            })(window, document, 'script')
        }
    }
})();